module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMDI0IDEwMjQiIHZlcnNpb249IjEuMSI+PHBhdGggZD0iTTMzOS4yIDk4MS4ybDAtOTAyLjYgMjk5LjIgMCAwIDkwMi42TDMzOS4yIDk4MS4yeiIgZmlsbD0iIzIzMTgxNSIgcC1pZD0iNjI4Ij48L3BhdGg+PC9zdmc+"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/i.svg
// module id = SkHj
// module chunks = 75